import type { ReactNode } from "react";

type BannerItem = {
  id: string | number;
  icon: ReactNode;
  label: string;
};

type BannerProps = {
  items: BannerItem[];
  speed?: number;
};

const DEFAULT_SPEED = 5000;
const BANNER_DUPLICATES = 3;

const Banner = ({ items, speed = DEFAULT_SPEED }: BannerProps) => {
  return (
    <div className="banner-small relative w-full overflow-hidden h-[105px] lg:h-[180px] sm:h-[180px] bg-[var(--pastel-blue)]">
      <div className="absolute flex h-full w-full bg-[var(--pastel-blue)]">
        {Array.from({ length: BANNER_DUPLICATES }, (_, i) => (
          <section 
            key={i} 
            style={{ 
              animation: `swipe ${speed}ms linear infinite`,
              animationPlayState: 'running'
            }} 
            className="flex animate-swipe"
          >
            {items.map(({ id, icon, label }) => (
              <div 
                key={`${id}-${i}`} 
                className="flex flex-col items-center justify-center max-w-[110px] sm:max-w-[220px] w-[90px] sm:w-[180px] text-center px-[5px] sm:px-[10px] py-1.5 sm:py-3 m-0.5 sm:m-1.5 box-border bg-white/[0.06]"
              >
                <div className="text-white flex items-center justify-center [&>svg]:w-12 sm:[&>svg]:w-24 [&>svg]:h-12 sm:[&>svg]:h-24 [&>img]:w-12 sm:[&>img]:w-24 [&>img]:h-12 sm:[&>img]:h-24 [&>img]:max-w-[75px] sm:[&>img]:max-w-[150px] [&>img]:h-auto [&>img]:p-0 [&>img]:object-contain [&>img]:w-auto">
                  {icon}
                </div>
                <p className="text-xs sm:text-xl mt-1 sm:mt-2 font-bold text-white capitalize font-medium tracking-wider">
                  {label}
                </p>
              </div>
            ))}
          </section>
        ))}
      </div>
      
      <style jsx>{`
        @keyframes swipe {
          0% {
            transform: translate(0);
          }
          100% {
            transform: translate(-100%);
          }
        }

        @media (max-width: 359px) {
          .banner-small {
            height: 52.5px !important;
          }
          .banner-small [class*="flex-col"] {
            gap: 2px !important;
          }
          .banner-small [class*="text-xs"] {
            font-size: 0.5rem !important;
          }
          .banner-small [class*="w-12"] {
            width: 24px !important;
            height: 24px !important;
          }
          .banner-small [class*="mt-1"] {
            margin-top: 0.25rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Banner;